import React from 'react';
import { GetStartedLinks, GetStartedLinkItem } from './GetStartedLinks';

const GetStartedResourceLinks = () => (
  <GetStartedLinks title={'Resources'}>
    <GetStartedLinkItem
      type="link"
      label={'Kubit Help Center'}
      url="https://docs.kubit.ai/docs/getting-started"
      isExternal={true}
    />
    <GetStartedLinkItem
      type="link"
      label={'Onboarding Video'}
      url="https://docs.kubit.ai/docs/introduction-to-kubit-video"
      isExternal={true}
    />
  </GetStartedLinks>
);

export default GetStartedResourceLinks;
